import React from 'react';
import { Button } from '@mui/material';

// Hooks
import useUser from '../../../hooks/useUser';

// Styles
import { useStyles } from './ReorderButtonStyles';

const Reorder = ({
  order,
  kit,
  onClick,
  inTable,
  className,
  disabled = false,
  title = 'Reorder',
}) => {
  const { isKiteUser } = useUser();
  const { classes, cx } = useStyles({ isKiteUser, inTable });

  return (
    <Button
      variant="contained"
      disabled={disabled}
      className={cx(classes.button, className)}
      onClick={() => onClick(order ? order : kit)}
      id="reorder"
      data-testid={'reorder-button'}>
      {title}
    </Button>
  );
};

export default Reorder;
